import { Box, Chip } from '@material-ui/core';
import { AppliedFilters } from 'views/components/careConnectPage/ClientCare/ClientTabPage';
import './FilterChips.css';
import { RECOMMENDED_HOURS_RANGE } from 'utils/constants/calendarFilters';

const FilterChips: React.FC<{
  appliedFilters: AppliedFilters;
  onRemoveFilter: (filterType: string, value?: string) => void;
}> = ({ appliedFilters, onRemoveFilter }) => {
  const chips: Array<{
    key: string;
    label: string;
    filterType: string;
    value?: string;
  }> = [];

  if (
    appliedFilters.carePlanstatus &&
    appliedFilters.carePlanstatus.length > 0
  ) {
    appliedFilters.carePlanstatus.forEach(status => {
      chips.push({
        key: `carePlan-${status}`,
        label: `Care Plan Status - ${status}`,
        filterType: 'carePlanstatus',
        value: status
      });
    });
  }

  if (
    appliedFilters.isWaitlistReason &&
    appliedFilters.isWaitlistReason.length > 0
  ) {
    appliedFilters.isWaitlistReason.forEach(reason => {
      chips.push({
        key: `waitlist-${reason}`,
        label: `WL Reason - ${reason}`,
        filterType: 'isWaitlistReason',
        value: reason
      });
    });
  }

  if (
    appliedFilters.isJumpstarter !== null &&
    appliedFilters.isJumpstarter !== undefined
  ) {
    chips.push({
      key: 'jumpstarter',
      label: `Jumpstarter - ${appliedFilters.isJumpstarter ? 'Yes' : 'No'}`,
      filterType: 'isJumpstarter'
    });
  }

  if (appliedFilters.isVBC !== null && appliedFilters.isVBC !== undefined) {
    chips.push({
      key: 'vbc',
      label: `VBC - ${appliedFilters.isVBC ? 'Yes' : 'No'}`,
      filterType: 'isVBC'
    });
  }
  if (
    appliedFilters.recommendedHoursRange !== null &&
    appliedFilters.recommendedHoursRange !== undefined &&
    (appliedFilters.recommendedHoursRange[0] !== RECOMMENDED_HOURS_RANGE[0] ||
      appliedFilters.recommendedHoursRange[1] !== RECOMMENDED_HOURS_RANGE[1])
  ) {
    chips.push({
      key: 'recommendedHoursRange',
      label: `Recommended Hours Range - ${appliedFilters.recommendedHoursRange[0]} - ${appliedFilters.recommendedHoursRange[1]}`,
      filterType: 'recommendedHoursRange'
    });
  }

  if (
    appliedFilters.checkedInsuranceCategories &&
    appliedFilters.checkedInsuranceCategories.length > 0
  ) {
    appliedFilters.checkedInsuranceCategories.forEach(category => {
      chips.push({
        key: `insuranceCat-${category}`,
        label: `Insurance Category - ${category}`,
        filterType: 'checkedInsuranceCategories',
        value: category
      });
    });
  }

  if (
    appliedFilters.checkedInsurancePayors &&
    appliedFilters.checkedInsurancePayors.length > 0
  ) {
    appliedFilters.checkedInsurancePayors.forEach(payor => {
      chips.push({
        key: `insurancePayor-${payor}`,
        label: `Insurance Payor - ${payor}`,
        filterType: 'checkedInsurancePayors',
        value: payor
      });
    });
  }

  if (
    appliedFilters.checkedInsurancePlans &&
    appliedFilters.checkedInsurancePlans.length > 0
  ) {
    appliedFilters.checkedInsurancePlans.forEach(plan => {
      chips.push({
        key: `insurancePlan-${plan}`,
        label: `Insurance Plan - ${plan}`,
        filterType: 'checkedInsurancePlans',
        value: plan
      });
    });
  }

  if (chips.length === 0) return null;

  return (
    <Box display="flex" flexWrap="wrap" mt={2} mb={2} style={{ gap: '8px' }}>
      {chips.map(chip => (
        <Chip
          key={chip.key}
          label={chip.label}
          onDelete={() => onRemoveFilter(chip.filterType, chip.value)}
          className="FilterChip"
          deleteIcon={
            <Box component="span" className="FilterChipDeleteIcon">
              ×
            </Box>
          }
        />
      ))}
    </Box>
  );
};

export default FilterChips;
